import { getAuthentication } from '@/hooks/useAuthentication';
import { RowData } from '@/pages/manage-users/hooks/useImportStaff';
import axios from 'axios';

export async function importStaff(schoolId: string, users?: RowData[]) {
  let data, error;

  try {
    const { data: response } = await axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_URL}/api/school/import-staff`,
      data: { schoolId, users },
      headers: { Authorization: `Bearer ${getAuthentication()?.accessToken}` },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}

export async function inviteStaff(schoolId: string, preview?: boolean) {
  let data, error;

  try {
    const { data: response } = await axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_URL}/api/school/invite-staff`,
      data: { schoolId, preview },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}

export async function getListStaff(schoolId: string) {
  let data, error;

  try {
    const { data: response } = await axios({
      method: 'get',
      url: `${import.meta.env.VITE_API_URL}/api/school/list-staff`,
      params: { schoolId: schoolId },
      headers: { Authorization: `Bearer ${getAuthentication()?.accessToken}` },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}
